module.exports = __webpack_public_path__ + "images/arrow-line@2x-b46147dbd93c340d3fcb5b638f2b12f8.png";